import { UserPlanVo, UserProfile } from "@/api";
import creditIcon from "@/assets/images/credit-icon.png";
import { useDeviceDetection } from "@/hooks/useDeviceDetection";
import { formatNumberWithCommas } from "@/util/formatNumber";
import Image from "next/image";
import Link from "next/link";
import React from "react";

interface CreditPlanLinkProps {
  userLoading: boolean;
  user: UserProfile | null;
  userPlan: UserPlanVo | null;
  isGifted?: boolean;
  userCredits: number;
}

export const CreditPlanLink: React.FC<CreditPlanLinkProps> = ({
  userLoading,
  user,
  userPlan,
  isGifted,
  userCredits,
}) => {
  const { isMobile } = useDeviceDetection();

  if (userLoading) {
    return null;
  }

  const content = (
    <div className="flex items-center gap-2 px-4 py-2 font-medium rounded-full border border-text-primary/[.07] bg-black/20 backdrop-blur-xl text-text-primary cursor-pointer transition-all hover:bg-primary/[.15] hover:backdrop-blur-none">
      {user ? (
        <>
          <span className="flex items-center gap-2">
            <Image src={creditIcon} alt="Credit" width={14} height={14} />
            <span>{formatNumberWithCommas(userCredits)}</span>
          </span>
          <div className="w-px h-[15px] bg-white/60 hidden sm:block"></div>

          <span className="hidden sm:flex items-center gap-1">
            {userPlan ? userPlan.memberShipName : user ? "" : "Free"}
            {isGifted && (
              <span className="px-1.5 py-0.5 rounded-[6px] text-[#F9C9FF] text-[11px] font-bold bg-[#F9C9FF]/10">
                Gifted
              </span>
            )}
          </span>
        </>
      ) : (
        <span className="text-text-primary!">Pricing</span>
      )}
    </div>
  );

  if (isMobile) {
    return content;
  }

  return (
    <Link href="/pricing" className="block" data-disable-progress={true}>
      {content}
    </Link>
  );
};
